<template>
  <div @click="navigateToTraceLandmass" ref="traceSourceMarker" style="display: flex;flex-direction: column;align-items: center">
    <div class="marker-image mid-center">
      <div class="mid-center" style="position: absolute;top: 1px;left: 1px;;width: 44px;height: 44px;border-radius: 33%;background: rgba(255, 255, 255, 0.5)">
        <img style="width: 40px;height: 40px;border-radius: 33%;" :src="markerInfo.thumb">
      </div>
    </div>
    <div class="marker-name">
      {{ markerInfo.title }}
    </div>
  </div>
</template>

<script>
import mapboxgl from "mapbox-gl";

export default {
  props: ['markerInfo'],
  data() {
    return {
      marker: '',
    }
  },
  methods: {
    navigateToTraceLandmass() {
      // eslint-disable-next-line no-undef
      if (typeof wx !== 'undefined' && wx.miniProgram){
        // eslint-disable-next-line no-undef
        wx.miniProgram.navigateTo({url: '/pages/trace_land_mass/traceLandMass?productId=' + this.markerInfo.mainId})
      }
    }
  },
  mounted() {
    const geo = JSON.parse(this.markerInfo.geo)
    this.marker = new mapboxgl.Marker(this.$refs.traceSourceMarker)
        .setLngLat(geo.coordinates)
        .addTo(this.$parent.$parent.map)
  },
  beforeUnmount() {
    this.marker.remove()
  }
}
</script>

<style scoped>
.mid-center {
  display: flex;
  align-items: center;
  justify-content: center;
}

.marker-image {
  width: 46px;
  height: 46px;
  border-radius: 33%;
  border: 1px solid transparent;
  background:
       padding-box,
      linear-gradient(185.75deg, rgba(70, 214, 62, 0.3) 0%, rgba(70, 214, 62, 1) 50%, rgba(70, 214, 62, 1) 100%) border-box;
  background-clip: padding-box, border-box;
  background-origin: padding-box, border-box;
  position: relative;
}

.marker-name {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 5px;
  height: 18px;
  color: white;
  font-size: 11px;
  font-weight: 500;
  padding-left: 4px;
  padding-right: 4px;
  border-radius: 50px;
  background: rgba(36, 71, 212, 0.3);
}
</style>